import React, {ReactNode} from "react";
import {Clip, Highlight} from "../../types/clipTypes";
import {Box, Typography} from "@mui/material";
import {useTheme} from "../../contexts/theme";
import {formatDuration} from "../../utils/dateTimeutils";
import {TrimPoint} from "../../types/editor";
import {getClipTrimDuration} from "../../utils/utils";


interface VideoEditorHeaderPopupProps {
    clip: Clip | Highlight;
    title: string;
    trimPoints: TrimPoint[];
}

const VideoEditorPopupHeader: React.FC<VideoEditorHeaderPopupProps> = ({clip, title, trimPoints}) => {

    const theme = useTheme();

    const headerKeyStyle = {
        color: theme.palette.white,
        fontSize: theme.fontSizes.description,
        paddingRight: theme.spacing.sm,
        padding: `${theme.spacing.xs}`
    };
    const headerValueStyle = {
        color: theme.palette.white,
        fontSize: theme.fontSizes.description,
        fontWeight: theme.fontWeights.value,
        borderRadius: theme.border.radius.sm,
        border: `${theme.border.width.thin} ${theme.border.type.solid} ${theme.palette.white}`,
        padding: `${theme.spacing.xs}`
    };



    return (
        <Box display="flex" flex={1} justifyContent="space-between">
            <Typography sx={{color: theme.palette.white, fontSize: theme.fontSizes.title, fontWeight: theme.fontWeights.title}}>{title}</Typography>
            <Box display={"flex"} justifyContent={"space-between"} gap={theme.spacing.md} marginRight={theme.spacing.md}>
                {
                    'key_moment_type' in clip && 'game_time' in clip && <>
                        <Box display={"flex"}>
                            <Typography sx = {headerKeyStyle}>Event </Typography>
                            <Typography sx = {headerValueStyle}>{clip.key_moment_type}</Typography>
                        </Box>
                        <Box display={"flex"}>
                            <Typography sx = {headerKeyStyle}>Time </Typography>
                            <Typography sx = {headerValueStyle}>{clip.game_time}</Typography>
                        </Box>
                    </>
                }
                <Box display={"flex"}>
                    <Typography sx = {headerKeyStyle}>Duration </Typography>
                    <Typography sx = {headerValueStyle}>{formatDuration(getClipTrimDuration(trimPoints, clip))}</Typography>
                </Box>
            </Box>
        </Box>
    );

}

export default VideoEditorPopupHeader;